import { InputAdornment, TextField } from '@mui/material';
import type { DateInputProps } from './types';

/**
 * Reusable native date text box (`<input type="date">`).
 *
 * Single responsibility: render a date field with a normalized string API and
 * the shared date defaults (`type="date"`, `size="small"`, shrunk label). It
 * owns no clear button or other affordance — a consumer that wants one passes it
 * through `endAdornment`. Styling is delegated via `className` / `sx`, so it
 * drops into any context — filter panel, column header, or a plain form.
 */
export function DateInput({
  value,
  onChange,
  min,
  max,
  fullWidth = false,
  className,
  ariaLabel,
  sx,
  endAdornment,
}: DateInputProps) {
  return (
    <TextField
      size="small"
      type="date"
      fullWidth={fullWidth}
      value={value}
      onChange={e => onChange(e.target.value)}
      className={className}
      sx={sx}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: { min, max, ...(ariaLabel ? { 'aria-label': ariaLabel } : {}) },
        ...(endAdornment && {
          input: {
            endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>,
          },
        }),
      }}
    />
  );
}
